/**
 * Return a unique array of primitive members
 * Sorts the array
 * @private
 */
export const arrayUnique = <T>(array: T[]): T[] =>
    array.sort().filter((item, pos, ary) => !pos || item !== ary[pos - 1]);
